// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"mO-z","carouselContainer":"nO-z"};